import { Component, Output, EventEmitter, forwardRef, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import pickmeup from 'pickmeup';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/bufferCount';
import 'rxjs/add/observable/fromEvent';

const noop = () => {};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DaterangeComponent),
  multi: true
};

export interface DateRange {
  beginDate: Date;
  endDate: Date;
}

@Component({
  selector: 'app-daterange',
  templateUrl: './daterange.component.html',
  styleUrls: ['./daterange.component.css'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class DaterangeComponent implements ControlValueAccessor, OnInit {

  @Output('change')change = new EventEmitter();
  @ViewChild('pickerElement')pickerElement: ElementRef;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  public innerValue: any;
  private pickerSettings = {
    mode: 'range',
    calendars: 2,
    hide_on_select: true,
    change: (val) => { this.value = val; }
  };

  constructor() {}

  // get accessor
  get value() {
    return this.innerValue;
  };

  // set accessor including call the onchange callback
  set value(v) {
    if (Boolean(v)) {
      this.innerValue = {
        beginDate: v[0],
        endDate: v[1]
      };
      this.onChangeCallback(this.innerValue);
    }
  }

  // Записываем начальное состояние модели
  writeValue(value: DateRange) {
    if (value) {
      this.value = value;
      this.setDate(value);
      this.onChangeCallback(value);
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private eventsBinding() {
    const element = this.pickerElement.nativeElement;
    const stream = Observable.fromEvent(element, 'pickmeup-change');
    stream.bufferCount(2)
      .map((events: any) => events[1].detail.date)
      .map(dates => {
        dates[1] = new Date(dates[1].setDate(dates[1].getDate() + 2));
        return dates;
      })
      .subscribe(dates => {
        this.value = dates;
        this.change.emit(this.value);
      });
  }

  private setDate(dates) {
  	if (pickmeup) {
		pickmeup(this.pickerElement.nativeElement, this.pickerSettings)
		  .set_date([dates.beginDate, dates.endDate]);
	}
  }

  ngOnInit() {
	if (pickmeup) {
		pickmeup(this.pickerElement.nativeElement, this.pickerSettings);
	}
	this.eventsBinding();
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/daterange/daterange.component.ts